import { render } from "./HelloWorld.vue?vue&type=template&id=250d1ecf&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=250d1ecf&scoped=true&lang=scss"

import exportComponent from "/builds/lukas/lukasrunge.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250d1ecf"]])

export default __exports__